module.exports = __webpack_public_path__ + "img/PDM-600-Mobile-Trafo2.dd8c0a9cd5fde2d8fe0c96eebfb6d52a.avif";